import { Component, Input, Output, EventEmitter } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';


@Component({
  selector: 'admin-nav-tabs',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './admin-nav-tabs.component.html',
  styleUrl: './admin-nav-tabs.component.scss'
})
export class AdminNavTabsComponent {
  @Input() activeTab: string = 'colleagues';
  @Output() tabChange = new EventEmitter<string>();

  tabs = [
    { label: 'Kollégák', icon: 'group', value: 'colleagues' },
    { label: 'Logok', icon: 'list_alt', value: 'logs' },
    { label: 'Termékek', icon: 'inventory_2', value: 'products' },
    { label: 'Beállítások', icon: 'settings', value: 'settings' },
    { label: 'Rendszer', icon: 'monitor_heart', value: 'monitoring' }
  ];

  selectTab(tabValue: string) {
    this.tabChange.emit(tabValue);
  }
}
